import { render, staticRenderFns } from "./Asignacion.vue?vue&type=template&id=68b642ea&scoped=true&"
import script from "./Asignacion.vue?vue&type=script&lang=ts&"
export * from "./Asignacion.vue?vue&type=script&lang=ts&"
import style0 from "./Asignacion.vue?vue&type=style&index=0&id=68b642ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b642ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68b642ea', component.options)
    } else {
      api.reload('68b642ea', component.options)
    }
    module.hot.accept("./Asignacion.vue?vue&type=template&id=68b642ea&scoped=true&", function () {
      api.rerender('68b642ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/AsignacionMandante/Asignacion.vue"
export default component.exports